import React, {useState, useContext, useEffect, useRef} from 'react';
import useStyles from './styles';
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdRefresh, MdCheck } from "react-icons/md";
import {useHistory} from 'react-router';

import Header from '../../components/Header'
import OptionsBaloom from '../../components/OptionsBaloom'
import BallClickEffect from '../../components/BallClickEffect'
import Loading from '../../components/Loading'
import Modal from '../../components/Modal';
import About from './subpages/about'
import Vote from './subpages/vote'
import Results from './subpages/results'
import Members from './subpages/members'

import api from '../../services/api';
import AppContext from '../../redux/contexts/appContext';
import ObtionsBaloom from '../../components/OptionsBaloom';

function Room({room, onVote, selectedSubPageState, changeSubPage, onRoomRemove, loading, onDelete, onExit, onShowVotes, onResetVotes, showRoomVotes, onRevert, onBan, onRemove}) {
  const c = useStyles();
  const {state, dispatch} = useContext(AppContext);
  const [isOptsOpen, setOptsOpen] = useState(false);
  const history = useHistory();
  const dotsRef = useRef(null);
  const resetBtnRef = useRef(null);
  const [subPages, setSubPages] = useState([]);


  const [deleteModal, setDeleteModal] = useState(false);
  const [exitModal, setExitModal] = useState(false);
  const [showVotesModal, setShowVotesModal] = useState(false);
  const [showResetVotesModal, setShowResetVotesModal] = useState(false);

  const handleSubPageChange = (to) => {
    changeSubPage(to);
  }

  
  const closeModal= () => {
    setExitModal(false);
    setDeleteModal(false);
    setShowVotesModal(false);
    setShowResetVotesModal(false);
  }

  const showVotes = () => {
    onShowVotes();
    setShowVotesModal(false);
  } 

  const resetVotes = () => {
    onResetVotes();
    setShowResetVotesModal(false);
  }


  useEffect(() => {
    const mouseClickListener = (e) => {
      if (dotsRef.current && !dotsRef.current.contains(e.target)) {
        setOptsOpen(false)
      }
    }

    document.addEventListener("mousedown", mouseClickListener);
    var unlisten = history.listen(() => {
      document.removeEventListener("mousedown", mouseClickListener);
      unlisten();
    })
  }, [])

  useEffect(() => {
    document.title = `${room && room.title} - Easy Scrum`

    setSubPages([{name: "About", show: true}, {name: "Vote", show:  room && state.user &&  state.user.id !== room.creatorId ? true : false}, {name: "Members", show:  room && state.user &&  state.user.id == room.creatorId ? true : false}, {name: "Results", show: true}])
  },[room])
  
 

  return (
    <>
      <title>Easy Scrum - Room {room && room.roomCode}</title>
      <Header roomJoin></Header>
      <div className={"container " + state.theme} >
        <div className={c.container}>
          <div className={c.loading}>
            {loading && <Loading size={30}/>}
          </div>
          

          <div className={c.roomHeader}>
            <div className={c.htop}>
              <h1 className={!room?.title ? "loading" : ""} style={{minWidth: 200}}>{room?.title || ""}</h1>
              <h3>
                <span>Room Code:</span>
                <div className={c.roomCode + " " + (!room?.roomCode ? "loading" : "")} style={{minWidth: 64}}>
                {room?.roomCode.toUpperCase() || ""}

                </div>
                
                {room?.creatorId == state.user.id && !room.showVotes && (
                  <BallClickEffect style={{borderRadius: '50%', marginLeft: 10, height: 30, width: 30}}>
                    <div className={c.dots}onClick={() => setShowVotesModal(true)}>
                        <MdCheck ></MdCheck>
                      </div>
                  </BallClickEffect>
                )}
                {room?.creatorId == state.user.id  && (
                  <BallClickEffect style={{borderRadius: '50%', marginLeft: 10, height: 30, width: 30}}>
                    <div className={c.dots}onClick={() => setShowResetVotesModal(true)}>
                        <MdRefresh ></MdRefresh>
                      </div>
                  </BallClickEffect>
                )}
                
                <OptionsBaloom.Container ref={dotsRef} >
                  <BallClickEffect selected={isOptsOpen} style={{borderRadius: '50%', marginLeft: 10}}>
                    <div className={c.dots}onClick={() => setOptsOpen(!isOptsOpen)}>
                      <BsThreeDotsVertical ></BsThreeDotsVertical>
                    </div>
                  </BallClickEffect>
                  <OptionsBaloom 
                    open={isOptsOpen} 
                    options={room?.creatorId == state.user.id ? 
                      [
                        {text: "Show Votes", onClick: () => setShowVotesModal(true), show: !room.showVotes},
                        {text: "Reset Votes", onClick: () => setShowResetVotesModal(true), show: room.votes.length > 0},
                        {text: "Delete", onClick: () => setDeleteModal(true)},
                      ] 
                      : 
                      [{text: "Exit", onClick: () => setExitModal(true)}]} 
                    />
                </OptionsBaloom.Container>
                


              </h3>
            </div>
            <div className={c.hbot}>
              {!room ? 
                <>
                  <BallClickEffect key={"loading-btn-1"} selected={true} style={{height: '100%',  display: 'flex',  borderTopRightRadius: 10,  borderTopLeftRadius: 10, margin: '0 10px',}}>
                      <a className={c.subpageA + " selected loading"} style={{minWidth: 85}}>
                        
                      </a>  
                  </BallClickEffect>
                  <BallClickEffect key={"loading-btn-2"} style={{height: '100%',  display: 'flex',  borderTopRightRadius: 10,  borderTopLeftRadius: 10, margin: '0 10px',}}>
                      <a className={c.subpageA + " loading"} style={{minWidth: 85}}>
                        
                      </a>  
                  </BallClickEffect>
                  <BallClickEffect key={"loading-btn-3"} style={{height: '100%',  display: 'flex',  borderTopRightRadius: 10,  borderTopLeftRadius: 10, margin: '0 10px',}}>
                      <a className={c.subpageA + " loading"} style={{minWidth: 85}}>
                        
                      </a>  
                  </BallClickEffect>  
                </>
              :
              subPages && subPages.map((page, index) => {
                if (page.show !== false) {
                  return(
                    <BallClickEffect key={"room-subpages-"+index} selected={selectedSubPageState === page.name} style={{height: '100%',  display: 'flex',  borderTopRightRadius: 10,  borderTopLeftRadius: 10, margin: '0 10px',}}>
                      <a onClick={() => handleSubPageChange(page.name)} className={c.subpageA + " " + (selectedSubPageState === page.name ? "selected" : "")}>
                        {page.name}
                        {selectedSubPageState === page.name && <div className={c.selection}></div>}
                      </a>  
                    </BallClickEffect>
                  )
                }
              })
              }
              
            </div>
          </div>
          
          {selectedSubPageState === "About" ? 
          <About c={c} members={room?.members || []} description={room?.description}></About>
          : selectedSubPageState === "Vote" ?
          <Vote c={c} onVote={onVote} type={room?.roomType} members={room?.members || []}  votes={room?.votes || []} cards={room?.cards}></Vote>
          : selectedSubPageState === "Members" ?
          <Members c={c} onRevert={onRevert} onBan={onBan} onRemove={onRemove} onVote={onVote} type={room?.roomType} members={room?.members || []}  votes={room?.votes || []}></Members>
          : 
          <Results c={c} votes={room?.votes || []} type={room?.roomType} showVotes={room?.showVotes} cards={room?.cards}></Results>
          }

        </div>
      </div>

      <Modal autoHeight title="Delete Room" visible={deleteModal} onCancel={closeModal} onSubmit={() => onDelete()}>
          Do you really want to delete this room?
      </Modal>
      <Modal autoHeight title="Exit Room" visible={exitModal} onCancel={closeModal} onSubmit={() => onExit()}>
          Do you really want to exit this room?
      </Modal>
      <Modal autoHeight title="Show Votes" visible={showVotesModal} onCancel={closeModal} onSubmit={() => showVotes()}>
          Do you really want to show the room votes?
      </Modal>
      <Modal autoHeight title="Reset Votes" visible={showResetVotesModal} onCancel={closeModal} onSubmit={() => resetVotes()}>
          Do you really want to reset the room votes?
      </Modal>
    </>
  );
}

export default Room;